import { ApolloError } from '@apollo/client'
import { Tooltip } from 'bold-ui'
import { useAlert } from 'components/alert'
import { useErrorHandler } from 'components/error'
import { Form, SubmitButton } from 'components/form'
import { confirm } from 'components/modals/confirm'
import { useAlterarConfiguracaoAssinaturaRegistrosMutation } from 'graphql/hooks.generated'
import { FormRenderProps } from 'react-final-form'

import { ASSINATURA_DIGITAL_INATIVA_MESSAGE } from '../model-assinaturaDigital'
import { ServicoAssinaturaDigitalCard } from './ServicoAssinaturaDigitalCard'

interface AssinaturaRegistrosCardProps {
  habilitado: boolean
  baseHabilitada: boolean
}

export function AssinaturaRegistrosCard(props: Readonly<AssinaturaRegistrosCardProps>) {
  const { habilitado, baseHabilitada } = props
  const alert = useAlert()
  const handleRejection = useErrorHandler()
  const [alterar] = useAlterarConfiguracaoAssinaturaRegistrosMutation()

  const submitAlteracao = async (msg: string) => {
    try {
      await alterar({ variables: { habilitado: !habilitado } })
      alert('success', msg)
    } catch (error) {
      handleRejection(error as ApolloError)
    }
  }

  const handleSubmit = async () => {
    if (habilitado) {
      const confirmed = await confirm({
        title: 'Deseja desabilitar a assinatura de registros?',
        confirmLabel: 'Desabilitar',
      })()
      if (confirmed) await submitAlteracao('Assinatura de registros desabilitada com sucesso.')
    } else {
      await submitAlteracao('Assinatura de registros habilitada com sucesso.')
    }
  }

  const renderForm = (formProps: FormRenderProps) => (
    <ServicoAssinaturaDigitalCard
      habilitado={habilitado}
      titulo='Assinatura de registros'
      descricao={`Habilita a assinatura digital e download dos registros de atendimento através do módulo "Assinatura digital de documentos".`}
    >
      <Tooltip text={!habilitado && !baseHabilitada ? ASSINATURA_DIGITAL_INATIVA_MESSAGE : ''}>
        <SubmitButton
          kind='primary'
          size='small'
          handleSubmit={formProps.handleSubmit}
          disabled={!baseHabilitada || formProps.submitting}
        >
          {habilitado ? 'Desabilitar' : 'Habilitar'}
        </SubmitButton>
      </Tooltip>
    </ServicoAssinaturaDigitalCard>
  )

  return <Form onSubmit={handleSubmit} render={renderForm} />
}
